import {UD_FAILURE, UD_PENDING, UD_SUCCESS} from './constants'

const initialState = {
  error: null,
  isLoading: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UD_PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case UD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        ...action.payload,
      }
    case UD_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }
    default:
      return state
  }
}

export default reducer
